export class RefreshTokenModel {
    public token: string;
}